import styled from 'styled-components'

export const ReactSwitchButton = styled.span`
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 25px;
	height: 25px;
	border-radius: 45px;
	transition: 0.2s;
	box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);

	&.requirementsManagement {
		background: #1198bc;
	}
	&.agilePlanning {
		background: #a67eaf;
	}
	&.alm {
		background: #ed5023;
	}
	&.itsm {
		background: #f6d20c;
	}
	&.ppm {
		background: #723e95;
	}
	&.testManagement {
		background: #00afa4;
	}
	&.mostPopular {
		background: #0c68b2;
	}
	&.other {
		background: #ffffff;
	}

	&.selected {
		left: calc(100%);
		transform: translateX(-100%);
	}
`

export const ReactSwitchCheckbox = styled.input`
	height: 0;
	width: 0;
	visibility: hidden;
`

export const ReactSwitchLabel = styled.label`
	display: flex;
	flex: 0 0 50px;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	width: 50px;
	height: 25px;
	background-color: var(--grey-44);
	border: 1px solid var(--grey);
	border-radius: 100px;
	position: relative;
	transition: background-color 0.2s;

	&.switched {
		background-color: #ffffff;
	}
`

export const ReactSwitch = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	flex: 1 0 150px;

	p {
		font-size: var(--font-small-size);
		margin-left: 10px;
	}
`

export const FilterIndicators = styled.div`
	display: flex;
	justify-content: flex-end;
	position: absolute;
	width: 100%;
	bottom: 0;
	left: 0;

	span {
		content: '';
		width: 10px;
		height: 10px;
		border-radius: 50%;
		margin: 5px;
		border: 1px solid var(--grey-33);

		&.requirementsManagement {
			background: #1198bc;
		}
		&.agilePlanning {
			background: #a67eaf;
		}
		&.alm {
			background: #ed5023;
		}
		&.itsm {
			background: #f6d20c;
		}
		&.ppm {
			background: #723e95;
		}
		&.testManagement {
			background: #00afa4;
		}
		&.mostPopular {
			background: #0c68b2;
		}
		&.other {
			background: #ffffff;
		}

		&.selected {
			left: calc(100%);
			transform: translateX(-100%);
		}
	}
`
